module.exports = "/_next/static/images/Group-4995-0c8c4962e0a2013341e731029b94938d.svg";